module.exports = __webpack_public_path__ + "static/media/symbol.c2bbf78f.png";